import { ClientConfig } from './client-variables';
import { EnvironmentConfig } from './environment-variables';

export const environment = {
  production: false,
  ...ClientConfig,
  ...EnvironmentConfig
};
